<div class="jk-rich-editor">
  @if(label || !readonly()) {
  <header class="jk-rich-editor__heading">
    <label class="jk-rich-editor__label">{{ label || 'HTML 編輯器' }}
      @if(required()) {
      <span style="color:red;">*</span>
      }
    </label>
    @if(!readonly()) {
    <div class="jk-rich-editor__actions" role="group" aria-label="HTML 編輯器操作">
      <button type="button" (click)="pasteImage()" [disabled]="pastingImage()"
        aria-label="貼上圖片" matTooltip="貼上圖片">
        貼上圖片
      </button>
      <button type="button" id="btnToggleImages" (click)="toggleMinioImages()"
        [attr.aria-label]="showMinioImages ? '收起已上傳圖片' : '選擇已上傳圖片'"
        [matTooltip]="showMinioImages ? '收起已上傳圖片' : '選擇已上傳圖片'"
        [attr.aria-expanded]="showMinioImages">
        <span class="jk-rich-editor__icon" [innerHTML]="actionIcons.image" aria-hidden="true"></span>
      </button>
      <button type="button" (click)="toggleRawText()"
        [attr.aria-label]="showRawText ? '收起原始文字' : '查看原始文字'"
        [matTooltip]="showRawText ? '收起原始文字' : '查看原始文字'"
        [attr.aria-expanded]="showRawText">
        <span class="jk-rich-editor__icon" [innerHTML]="actionIcons.source" aria-hidden="true"></span>
      </button>
      <button type="button" (click)="pastePlainText()" aria-label="貼上文字" matTooltip="貼上文字">
        <span class="jk-rich-editor__icon" [innerHTML]="actionIcons.pasteText" aria-hidden="true"></span>
      </button>
      <button type="button" (click)="pasteHtml()" aria-label="貼上 HTML" matTooltip="貼上 HTML">
        <span class="jk-rich-editor__icon" [innerHTML]="actionIcons.pasteHtml" aria-hidden="true"></span>
      </button>
    </div>
    }
  </header>
  }
  @if(readonly()) {
  <quill-editor [ngModel]="editorValue" [readOnly]="true"
    [modules]="{toolbar: false}" theme="bubble"
    [style.min-height]="minHeight()"
    style="display:block; border:1px solid #ccc; border-radius:4px;">
  </quill-editor>
  } @else {
  <input #imageInput type="file" accept="image/*" style="display:none"
    (change)="onImageFileSelected($event)">
  <quill-editor theme="snow" [ngModel]="editorValue" (ngModelChange)="onModelChange($event)"
    [modules]="quillModules"
    [style.min-height]="minHeight()"
    style="display:flex; flex-direction:column; width:100%;"
    (onEditorCreated)="onQuillEditorCreated($event)">
  </quill-editor>
  @if(showRawText) {
  <textarea readonly [value]="editorValue"
    aria-label="原始 HTML 文字"
    style="display:block; width:100%; min-height:150px; margin-top:4px; padding:8px; box-sizing:border-box; font-family:monospace; font-size:12px; border:1px solid #ccc; border-radius:4px; background:#f8f8f8;"></textarea>
  }
  @if(showMinioImages) {
  <div style="border:1px solid #ddd; border-radius:4px; padding:8px; margin-top:4px; min-height:60px;">
    @if(minioImagesLoading) {
    <span style="color:#888; font-size:13px;">載入中...</span>
    } @else if(minioImages.length === 0) {
    <span style="color:#aaa; font-size:13px;">此單號尚無已上傳圖片</span>
    } @else {
    @for(img of minioImages; track img.url) {
    <img [src]="img.url" [title]="img.name"
      (click)="insertMinioImage(img.url)"
      style="width:100px; height:80px; object-fit:cover; cursor:pointer; margin:4px; border:1px solid #ccc; border-radius:4px;">
    }
    }
  </div>
  }
  }
</div>
